var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader-container"},[_c('div',{staticClass:"loader"},[_c('vue-loaders',{attrs:{"name":"ball-scale-ripple-multiple","color":"grey","scale":"1"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }